<template>
  <div>
    <custom-callout
      :border-color="model.status?.color"
      class="mt-3"
      controlled
      :has-toggle="!isFromCompany"
      :opened="isOpen"
      @click:open="onOpenClose"
    >
      <div class="row pt-2 ml-0 align-items-center">
        <!-- Estado -->
        <div class="col-12 col-md-2 d-flex align-items-center ">
          <custom-balloon
            :background-color="model.status?.color"
            dot
            :text="model.status?.name"
          />
        </div>

        <div v-if="!isFromCompany" class="col-12 col-lg-2 ">
          <div class="label">Nombre del Proveedor:</div>
          <div class="value">{{ model.company }}</div>
        </div>

        <div v-if="!isFromCompany" class="col-12 col-lg-2 ">
          <div class="label">Número de NPI:</div>
          <div class="value">{{ model.npi }}</div>
        </div>

        <div class="col-12 col-lg-2">
          <div class="label">Fecha Inicio:</div>
          <div class="value">{{ model.startDate | date('DD/MMM/YYYY') }}</div>
        </div>

        <div class="col-12 col-lg-2">
          <div class="label">Fecha Fin:</div>
          <div class="value">{{ model.endDate | date('DD/MMM/YYYY') }}</div>
        </div>

        <div v-if="isFromCompany" class="col-12 col-lg-2">
          <div class="label">Creado por:</div>
          <div class="value">{{ model.user }}</div>
        </div>

        <div v-if="isFromCompany" class="col-12 col-lg-2 ">
          <div class="label">Fecha de Creación:</div>
          <div class="value">{{ model.createdDate | date('DD/MMM/YYYY') }}</div>
        </div>

        <div
          class="col-12"
          :class="{
            'col-lg-1': isSubmitted && checkable,
            'col-lg-2': !(isSubmitted && checkable),
          }"
        >
          <drop-down :data-item="model" :items="availableActions" />
        </div>

        <div v-if="checkable && isSubmitted" class="col-12 col-lg-1">
          <div class="d-flex justify-content-center align-items-center h-100">
            <checkbox
              v-model="model.checked"
              checked-bg-color="bg-success"
              class="d-flex justify-content-center"
              icon="fal fa-check"
              @input="check(model)"
            />
          </div>
        </div>
      </div>
      <template #edition>
        <div class="bg-secondary-3 p-2">
          <!-- acción de información adicional -->
          <div
            v-if="isAdditionalInformation"
            class=" bg-white p-3 rounded mr-0 ml-0"
          >
            <div class="row">
              <div class="col-12 mb-3">
                <i class="fas fa-info-circle text-orange" />
                <strong class="ml-2">
                  Información Adicional
                </strong>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-lg-4 ">
                <div class="label">Tipo de Proveedor:</div>
                <div class="value">{{ model.companyType }}</div>
              </div>
              <div class="col-12 col-lg-4 ">
                <div class="label">Creado Por:</div>
                <div class="value">{{ model.user }}</div>
              </div>
              <div class="col-12 col-lg-4 ">
                <div class="label">Fecha de Creación:</div>
                <div class="value">
                  {{ model.createdDate | date('DD/MMM/YYYY') }}
                </div>
              </div>
            </div>
          </div>
          <!-- acción de cambiar de estatus -->
          <div v-if="isDenying" class="row bg-white p-3 rounded mr-0 ml-0">
            <div class="col-12 my-3">
              <i class="fas fa-times-circle text-red" />
              <strong class="ml-2">
                Denegar
              </strong>
            </div>
            <div class="col-12">
              <validation-provider
                v-slot="{ errors, validate }"
                :custom-messages="{
                  required: 'El campo es requerido.',
                }"
                rules="required"
              >
                <custom-text-area
                  v-model="statusComment"
                  :count-classes="['d-block', 'small-counter']"
                  :custom-error-msg="errors[0]"
                  :error="errors[0]"
                  label="Comentario:"
                  :maxlength="3000"
                  show-char-count
                />
                <div class="text-right mt-4">
                  <action-button
                    class="mr-2"
                    i="fas fa-times-circle"
                    variant="outline-danger"
                    @click="onCancel"
                  >
                    Cancelar
                  </action-button>

                  <action-button
                    i="fas fa-save"
                    variant="success"
                    @click="() => changeStatus(validate)"
                  >
                    Guardar
                  </action-button>
                </div>
              </validation-provider>
            </div>
          </div>
          <!-- acción de cambiar de estatus -->
          <div v-else-if="isViewHistory" class="bg-white p-3 rounded">
            <medicaid-history :item="model" />
          </div>
        </div>
      </template>
    </custom-callout>
    <custom-error
      v-if="alertUpcomingExpirationDateText && !alertExpiredDateText"
      is-alert-mode
      :message="alertUpcomingExpirationDateText"
      variant="mt-0 border-top-0"
    />
    <custom-error
      v-if="alertExpiredDateText"
      :message="alertExpiredDateText"
      variant="mt-0 border-top-0"
    />
  </div>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import CustomBalloon from 'custom-balloon';
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import _generalApi from '@/modules/app/api';
import medicaidEligibilityStatus from '@/utils/constants/medicaidEligibilityStatus';
import {
  changeStatus,
  revertStatus,
} from '@/modules/medicaid/medicaid-certification.api';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import MedicaidHistory from './MedicaidHistory.vue';
import Checkbox from 'CheckBox';
import CustomError from 'custom-error';
import moment from 'moment';

const ACTION = {
  VIEW_HISTORY: 0,
  APPROVE_ELIGIBILITY: 1,
  DENIE_ELIGIBILITY: 2,
  ADDITIONAL_INFORMATION: 3,
  RETURN_STATUS: 4,
};

export default {
  name: 'MedicaidRowResult',
  components: {
    CustomBalloon,
    CustomCallout,
    DropDown,
    CustomTextArea,
    MedicaidHistory,
    Checkbox,
    CustomError,
  },
  mixins: [alertMixin],
  props: {
    model: {
      type: Object,
      default: () => ({}),
    },
    isFromCompany: {
      type: Boolean,
      default: () => false,
    },
    checkable: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      isOpen: false,
      statusComment: '',
      action: -1,
    };
  },
  computed: {
    availableActions() {
      return [
        {
          name: 'downloadDocument',
          label: 'Descargar Documento',
          icon: 'fas fa-file-download text-green',
          visible: true,
          click: () => this.onDownloadHandler(this.model.documentId),
        },
        {
          name: 'additionalInformation',
          label: 'Información Adicional',
          icon: 'fas fa-info-circle text-green',
          visible: !this.isFromCompany,
          click: () => {
            this.action = ACTION.ADDITIONAL_INFORMATION;
            this.isOpen = true;
          },
        },
        {
          name: 'viewHistory',
          label: 'Historial de Estatus',
          icon: 'fas fa-history text-green',
          visible: true,
          click: () => {
            this.action = ACTION.VIEW_HISTORY;
            this.isOpen = true;
          },
        },
        {
          name: 'approveEligibility',
          label: 'Aprobar',
          icon: 'fas fa-check-circle text-green',
          visible: this.isAllowedToChangeStatus,
          click: () => {
            this.action = ACTION.APPROVE_ELIGIBILITY;
            this.changeStatus();
          },
        },
        {
          name: 'denieEligibility',
          label: 'Denegar',
          icon: 'fas fa-times-circle text-red',
          visible: this.isAllowedToChangeStatus,
          click: () => {
            this.action = ACTION.DENIE_ELIGIBILITY;
            this.isOpen = true;
            this.statusComment = '';
          },
        },
        {
          name: 'revertEligibilityStatus',
          label: 'Regresar Estatus',
          icon: 'far fa-sync text-green',
          visible: this.isAllowedToReturnStatus,
          click: () => {
            this.action = ACTION.RETURN_STATUS;
            this.revertEligibilityStatus();
          },
        },
      ];
    },
    isAllowedToChangeStatus() {
      return (
        [medicaidEligibilityStatus.Submitted].includes(this.model.status?.id) &&
        this.userHasPermissions(
          'provider.providers.medicaideligibility.determine'
        )
      );
    },
    isAllowedToReturnStatus() {
      return (
        [
          medicaidEligibilityStatus.Approved,
          medicaidEligibilityStatus.Denied,
        ].includes(this.model.status?.id) &&
        this.userHasPermissions(
          'provider.providers.medicaideligibility.returnstatus'
        )
      );
    },
    isDenying() {
      return this.action === ACTION.DENIE_ELIGIBILITY;
    },
    isViewHistory() {
      return this.action === ACTION.VIEW_HISTORY;
    },
    isAdditionalInformation() {
      return this.action === ACTION.ADDITIONAL_INFORMATION;
    },
    isSubmitted() {
      return this.model.status.id === medicaidEligibilityStatus.Submitted;
    },
    alertUpcomingExpirationDateText() {
      const endDate = moment(this.model.endDate).startOf('day');
      const today = moment().startOf('day');

      let tempDate = moment(endDate);
      tempDate.subtract(5, 'day');

      if (tempDate.isSameOrBefore(today) && endDate.isSameOrAfter(today)) {
        return `Fecha de certificación está próxima a vencer (${moment(endDate)
          .locale('es-PR')
          .format('DD/MMM/YYYY')}).`;
      }

      return null;
    },
    alertExpiredDateText() {
      const endDate = moment(this.model.endDate).startOf('day');
      const today = moment().startOf('day');
      const minDate = moment(today).subtract(2, 'days');

      if (endDate.isSameOrBefore(today) && endDate.isSameOrAfter(minDate)) {
        return `La certificación se encuentra vencida (${endDate
          .locale('es-PR')
          .format('DD/MMM/YYYY')}).`;
      }

      return null;
    },
  },
  methods: {
    onOpenClose() {
      this.action = ACTION.ADDITIONAL_INFORMATION;
      this.isOpen = !this.isOpen;
    },
    async revertEligibilityStatus() {
      try {
        const confirmation = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea regresar al estatus Sometido la elegibilidad?.`,
          'Si',
          'No'
        );
        if (!confirmation) return;

        await revertStatus(this.model.id, { comment: this.statusComment });
        this.ShowToast('Éxito', 'Actualizado correctamente', 'success');
        this.onCancel();
        this.$emit('refresh');
      } catch (error) {
        this.ShowToast(
          '',
          'No fue posible aprobar la solicitud. Intente nuevamente o contacte al administrador.',
          'error'
        );
      }
    },
    async changeStatus(validateFn = null) {
      if (validateFn) {
        const { valid } = await validateFn();
        if (!valid) return;
      }
      let confirmationMessage = '';
      let payload = {};

      switch (this.action) {
        case ACTION.APPROVE_ELIGIBILITY:
          confirmationMessage =
            '¿Está seguro que desea determinar en aprobada la elegibilidad?';
          payload = {
            statusId: medicaidEligibilityStatus.Approved,
          };
          break;
        case ACTION.DENIE_ELIGIBILITY:
          confirmationMessage =
            '¿Está seguro que desea determinar en denegada la elegibilidad?';
          payload = {
            statusId: medicaidEligibilityStatus.Denied,
            comment: this.statusComment,
          };
          break;
        default:
          return;
      }
      try {
        const confirmation = await this.ShowCancelModal(
          'Confirmación',
          confirmationMessage,
          'Si',
          'No'
        );

        if (!confirmation) return;

        await changeStatus(this.model.id, payload);
        this.ShowToast('Éxito', 'Actualizado correctamente', 'success');
        this.onCancel();
        this.$emit('refresh');
      } catch (error) {
        const message =
          error?.response?.data?.message || 'Error al actualizar el estatus';
        this.ShowToast('', message, 'error');
      }
    },
    onCancel() {
      this.statusComment = '';
      this.action = -1;
      this.isOpen = false;
    },
    async onDownloadHandler(fileId) {
      if (!fileId) return;

      try {
        await _generalApi.downloadDocumentByAttachmentId(fileId);
      } catch (e) {
        this.ShowToast &&
          this.ShowToast(
            'Error',
            'No se pudo descargar el documento. Intente nuevamente.',
            'error'
          );
      }
    },
    check(item) {
      this.$emit('check', item);
    },
  },
};
</script>

<style scoped>
.label {
  font-size: 11px;
  color: #828282;
}
.value {
  font-size: 13px;
  font-weight: 500;
}
</style>
